import { render, staticRenderFns } from "./app-sidebar.vue?vue&type=template&id=08df317a&scoped=true&"
import script from "./app-sidebar.vue?vue&type=script&lang=js&"
export * from "./app-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./app-sidebar.vue?vue&type=style&index=0&id=08df317a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08df317a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListTile } from 'vuetify/lib/components/VList';
import { VListTileContent } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VList,VListTile,VListTileContent,VNavigationDrawer})
